/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Svg,
  Path,
  Font,
} from "@react-pdf/renderer";
// import { imageBaseUrl } from "../utils/api";
import LyftImg from "../../Assets/lyftimg.png";
import CheckBox from "../../Assets/lyftCheckBox.png";
import TicketImg from "../../Assets/tickimg.png";

import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import { handDrawnCirclePath } from "../../utils/handDrawnCircle";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });

const MichiganHandCircle = () => (
  <Svg style={styles.michiganHandCircle} viewBox="0 0 112 73">
    <Path
      d={handDrawnCirclePath}
      stroke="#0d2c6c"
      strokeWidth={4}
      strokeLinecap="round"
      fill="none"
    />
  </Svg>
);

const styles = StyleSheet.create({
  body: {
    paddingBottom: 65,
  },
  headerWidth: {
    // paddingHorizontal: 10,
    marginBottom: "25px",
  },
  header: {
    backgroundColor: "#00B3AD",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
  },
  headerLogoContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerLine: {
    backgroundColor: "white",
    width: "2px",
    height: "30px",
    marginLeft: "20px",
    marginRight: "20px",
  },
  headerLogoText: {
    color: "white",
    fontSize: "20px",
  },
  californiaText: {
    color: "white",
    fontSize: "20px",
    textTransform: "uppercase",
  },
  boxContainer: {
    padding: "10px",
  },
  lyftdrivertextContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "15px",
  },
  boxWidth: {
    paddingHorizontal: 20,
    // paddingTop: 10,
  },
  lyftdriverText: {
    fontSize: "20px",
    fontStyle: "sans-serif",
    fontWeight: "bold",
    // lineHeight: "42px",
    color: "black",
    // fontFamily: "sans-serif",
    float: "left",
  },
  allfieldsText: {
    color: "#000",
    fontSize: "17px",
    fontWeight: "400",
    marginLeft: "370px",
  },
  nameinputContainer: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    // width: "100%",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "20px",
  },
  nameinputContain: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "20px",
    // width: "100%",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px",
  },
  lyftdriverName: {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "23px",
    color: "#47484F",
    marginBottom: 0,
    // width:"100px",
    marginTop: "3px",
  },
  lyftdriver: {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "23px",
    color: "#47484F",
    marginBottom: 0,
    // width:"100px",
    marginTop: "3px",
    borderTop: "3px solid #A6A4A4",
    paddingTop: "5px",
  },
  nameText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    // fontFamily: 'kalamFont',
    // lineHeight: "23px",
    color: "black",
    // width: "100%",
    borderBottom: "3px solid #A6A4A4",
  },
  threeinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "30px",
  },
  nameinputContainerOne: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "40%",
    marginRight: "10px",
  },
  nameinputContainerTwo: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "60%",
    // marginRight: "10px",
    marginLeft: "10px",
  },
  nameinputContainerThree: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "40%",
  },
  threeinputFields: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    // fontFamily: 'kalamFont',
    // lineHeight: "23px",
    color: "black",
    borderBottom: "3px solid #A6A4A4",
    // backgroundColor: 'red',
    marginBottom: "-3px",
  },
  licenseplateContainer: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    width: "40%",
    marginRight: "10px",
  },
  codeText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    marginLeft: "50%",
  },
  vinContainer: {
    fontSize: "12px",
    fontWeight: "30",
    fontStyle: "normal",
    color: "black",
  },
  twoinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px",
  },
  vintopBorder: {
    borderTopWidth: 1,
    borderTopColor: "#47484F",
    width: "100%",
  },
  topText: {
    marginTop: "30px",
    fontSize: "12px",
    paddingLeft: "8px",
    paddingRight: "10px",
  },
  vehicleinspectionPadding: {
    paddingHorizontal: "30px",
    paddingTop: "10px",
  },
  checkboxesmainContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
  },
  checkboxesmainContainerTwo: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
    marginTop: "10px",
  },
  inspectionfirstContainer: {
    width: "94%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionsecondContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionText: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  inspectiontextTwo: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginLeft: "15px",
    textTransform: "uppercase",
  },
  passText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginRight: "15px",
    textTransform: "uppercase",
  },
  failText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  passfailContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  numbersText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
  },
  detailsText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "black",
    marginLeft: "5px",
  },
  detailsText2: {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "700px",
    // lineHeight: "21@s",
    color: "#828282",
    marginLeft: "19px",
  },
  failpassbox: {
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "black",
    marginLeft: "15px",
    width: "92%",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    position: "absolute",
    height: "100px",
    top: 10,
  },

  boxinspectionText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    // lineHeight: "21px",
    color: "black",
    textTransform: "uppercase",
  },
  circleoneText: {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "21px",
    color: "#716E6E",
    marginLeft:"5px"
  },
  boxpassText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  orangeCircle: {
    borderWidth: 5,
    borderColor: "black",
    borderRadius: "50%",
    height: "75px",
    width: "75px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  michiganResultOption: {
    position: "relative",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: "14px",
  },
  michiganHandCircle: {
    position: "absolute",
    top: "-14px",
    left: "-12px",
    width: "90px",
    height: "55px",
  },
  boxfailText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  boxinspectionContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tobecompletedContainer: {
    backgroundColor: "#E4E5E7",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedWidth: {
    paddingHorizontal: "30px",
    marginTop: "150px",
  },
  tobecompletedtextContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedText: {
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "23px",
    color: "black",
    textDecoration: "underline",
    textTransform: "uppercase",
  },
  fieldsText: {
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },

  inpectionText: {
    fontSize: "16px",
    color: "#47484F",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  documentexpiryText: {
    fontSize: "12px",
    color: "#47484F",
  },
  dateText: {
    fontSize: "16px",
    letterSpacing: "1px",
  },
  datemainContainer: {
    marginTop: "10px",
    marginLeft: "52%",
  },
  namesfieldscontainer: {
    flexDirection: "row",
    // alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "18px",
    alignItems: "flex-end",
  },
  borderWidth: {
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  topName: {
    fontSize: "14px",
    color: "black",
    marginLeft: "12px",
  },
  bottomName: {
    fontSize: "12px",
    color: "#47484F",
    textTransform: "uppercase",
  },
  bottomPara: {
    paddingHorizontal: "30px",
    fontSize: 10,
    marginTop: "15px",
    color: "#716E6E",
  },
  tickpassContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  tickfailContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  inspectiondateContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "95%",
  },
});

function LyftCertificateMichiganDowmload({
  certificateData,
  vehicleChecksArray,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              <View style={styles.headerWidth}>
                <View style={styles.header}>
                  <View style={styles.headerLogoContainer}>
                    <Image style={{ width: "40px" }} source={LyftImg} />
                    <View style={styles.headerLine}></View>
                    <Text style={styles.headerLogoText}>MICHIGAN</Text>
                  </View>

                  <Text style={styles.californiaText}>VEHICLE INSPECTION</Text>
                </View>
              </View>
              <View style={styles.boxWidth}>
                <View style={styles.boxContainer}>
                  <View style={styles.lyftdrivertextContainer}>
                    <Text style={styles.lyftdriverText}>LYFT DRIVER INFO</Text>
                    <Text style={styles.allfieldsText}>
                      ALL FIELDS ARE MANDATORY
                    </Text>
                  </View>

                  <View style={styles.nameinputContainer}>
                    <View style={{ width: "50%", marginRight: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {certificateData &&
                          `${certificateData?.Username} ${
                               certificateData?.UserlastName
                             
                          }`}
                      </Text>
                      <Text style={styles.lyftdriverName}>
                        LYFT DRIVER NAME
                      </Text>
                    </View>
                    <View style={{ width: "50%", marginLeft: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {certificateData && certificateData?.Useremail}
                      </Text>
                      <Text style={styles.lyftdriverName}>EMAIL ADDRESS</Text>
                    </View>
                  </View>
                  <View style={styles.threeinputfieldContainer}>
                    <View style={styles.nameinputContainerOne}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.licensePlateNumber}
                      </Text>
                      <Text style={styles.lyftdriverName}>LICENSE PLATE #</Text>
                    </View>
                    <View style={styles.nameinputContainerTwo}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.vin}
                      </Text>
                      <Text style={styles.lyftdriverName}>VIN # </Text>
                    </View>
                  </View>
                  <View style={styles.twoinputfieldContainer}>
                    <View style={styles.licenseplateContainer}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.make}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MAKE</Text>
                    </View>
                    <View
                      style={{
                        width: "40%",
                        marginRight: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.model}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MODEL</Text>
                    </View>
                    <View style={{ width: "20%", marginLeft: "10px" }}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.year}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE YEAR</Text>
                    </View>
                  </View>
                  <View style={styles.nameinputContain}>
                    {/* <View
                      style={{
                        width: "40%",
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                    >
                      <Image
                          style={{
                            position: "absolute",
                            height: "100px",
                            width: "100px",
                            top: "-50px",
                            right: "100px",
                          }}
                          src={`${process.env.REACT_APP_AWS_S3_LINK}/${
                            certificateData && certificateData.Inspectorsignature
                          }?x-request=xhr`}
                        />
                      <Text style={styles.lyftdriver}>
                        LYFT DRIVER SIGNATURE
                      </Text>
                    </View> */}
                    <View style={{ width: "40%" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {certificateData && certificateData?.Userphone}
                      </Text>
                      <Text style={styles.lyftdriverName}>
                        LYFT DRIVER NUMBER
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.vehicleinspectionPadding}>
                <View style={styles.lyftdrivertextContainer}>
                  <Text style={styles.lyftdriverText}>VEHICLE INSPECTION</Text>
                </View>
              </View>
              {/* <View style={{ marginLeft: "20px" }}>
                <Text style={styles.inspectionpointsText}>
                  INSPECTION POINTS
                </Text>
                <View style={{ flexWrap: "wrap", flexDirection: "row" }}>
                  <Image
                    style={{
                      width: "100%",
                      marginLeft: -10,
                      // marginTop: "20px",
                    }}
                    source={CheckBox}
                  />
                </View>
              </View> */}
              <View style={{ flexDirection: "row", paddingHorizontal: "30px" }}>
                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>Inspection Point</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>Pass</Text>
                      <Text style={styles.failText}>Fail</Text>
                    </View>
                  </View>

                  {vehicleChecksArray?.map((check, index) =>
                    index <= 11 ? (
                      <>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Text style={styles.numbersText}>{index + 1}.</Text>
                            <Text style={styles.detailsText}>
                              {check.Check.name}
                            </Text>
                          </View>
                          <View style={styles.passfailContainer}>
                            {check.status == true || check.status == 1 ? (
                              <View style={styles.tickpassContainer}>
                                <Image
                                  style={{ width: "16px", marginLeft: "2px" }}
                                  source={TicketImg}
                                />
                              </View>
                            ) : (
                              <View style={styles.tickpassContainer}></View>
                            )}
                            {check.status == false || check.status == 0 ? (
                              <View style={styles.tickfailContainer}>
                                <Image
                                  style={{ width: "16px", marginLeft: "2px" }}
                                  source={TicketImg}
                                />
                              </View>
                            ) : (
                              <View style={styles.tickfailContainer}></View>
                            )}
                          </View>
                        </View>
                        {check?.Check?.SubChecks?.length > 0 &&
                          check?.Check?.SubChecks?.map((subCheck, index) => (
                            <View
                              style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <Text style={styles.detailsText}>
                                {subCheck?.checkName}
                              </Text>
                              <View style={styles.passfailContainer}>
                                {subCheck?.SubInspectionCheck?.status == true ||
                                subCheck?.SubInspectionCheck?.status == 1 ? (
                                  <View style={styles.tickpassContainer}>
                                    <Image
                                      style={{
                                        width: "16px",
                                        marginLeft: "2px",
                                      }}
                                      source={TicketImg}
                                    />
                                  </View>
                                ) : (
                                  <View style={styles.tickpassContainer}></View>
                                )}
                                {subCheck?.SubInspectionCheck?.status ==
                                  false ||
                                subCheck?.SubInspectionCheck?.status == 0 ? (
                                  <View style={styles.tickfailContainer}>
                                    <Image
                                      style={{
                                        width: "16px",
                                        marginLeft: "2px",
                                      }}
                                      source={TicketImg}
                                    />
                                  </View>
                                ) : (
                                  <View style={styles.tickfailContainer}></View>
                                )}
                              </View>
                            </View>
                          ))}
                      </>
                    ) : null
                  )}
                </View>

                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>Inspection Point</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>Pass</Text>
                      <Text style={styles.failText}>Fail</Text>
                    </View>
                  </View>

                  {vehicleChecksArray?.map((check, index) =>
                    index > 11 ? (
                      <>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Text style={styles.numbersText}>{index + 1}.</Text>
                            <Text style={styles.detailsText}>
                              {check.Check.name}
                            </Text>
                          </View>
                          <View style={styles.passfailContainer}>
                            {check.status == true || check.status == 1 ? (
                              <View style={styles.tickpassContainer}>
                                <Image
                                  style={{ width: "16px", marginLeft: "2px" }}
                                  source={TicketImg}
                                />
                              </View>
                            ) : (
                              <View style={styles.tickpassContainer}></View>
                            )}
                            {check.status == false || check.status == 0 ? (
                              <View style={styles.tickfailContainer}>
                                <Image
                                  style={{ width: "16px", marginLeft: "2px" }}
                                  source={TicketImg}
                                />
                              </View>
                            ) : (
                              <View style={styles.tickfailContainer}></View>
                            )}
                          </View>
                        </View>
                        {check?.Check?.SubChecks?.length > 0 &&
                          check?.Check?.SubChecks?.map((subCheck, index) => (
                            <>
                              {check?.Check?.category === "tire" ? (
                                <>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                      marginLeft: "18px",
                                    }}
                                  >
                                    <Text style={styles.detailsText2}>
                                      {subCheck?.checkName}
                                    </Text>
                                    <View style={styles.passfailContainer}>
                                      {subCheck?.SubInspectionCheck?.status ==
                                        true ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        1 ? (
                                        <View style={styles.tickpassContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickpassContainer}
                                        ></View>
                                      )}
                                      {subCheck?.SubInspectionCheck?.status ==
                                        false ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        0 ? (
                                        <View style={styles.tickfailContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickfailContainer}
                                        ></View>
                                      )}
                                    </View>
                                  </View>
                                </>
                              ) : (
                                <>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                      marginLeft: "18px",
                                    }}
                                  >
                                    <Text style={styles.detailsText2}>
                                      {subCheck?.checkName}
                                    </Text>
                                    <View style={styles.passfailContainer}>
                                      {subCheck?.SubInspectionCheck?.status ==
                                        true ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        1 ? (
                                        <View style={styles.tickpassContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickpassContainer}
                                        ></View>
                                      )}
                                      {subCheck?.SubInspectionCheck?.status ==
                                        false ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        0 ? (
                                        <View style={styles.tickfailContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickfailContainer}
                                        ></View>
                                      )}
                                    </View>
                                  </View>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                      marginLeft: "18px",
                                    }}
                                  >
                                    <Text style={styles.detailsText2}>
                                      Right front
                                    </Text>
                                    <View style={styles.passfailContainer}>
                                      {subCheck?.SubInspectionCheck?.status ==
                                        true ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        1 ? (
                                        <View style={styles.tickpassContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickpassContainer}
                                        ></View>
                                      )}
                                      {subCheck?.SubInspectionCheck?.status ==
                                        false ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        0 ? (
                                        <View style={styles.tickfailContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickfailContainer}
                                        ></View>
                                      )}
                                    </View>
                                  </View>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                      marginLeft: "18px",
                                    }}
                                  >
                                    <Text style={styles.detailsText2}>
                                      Left rear
                                    </Text>
                                    <View style={styles.passfailContainer}>
                                      {subCheck?.SubInspectionCheck?.status ==
                                        true ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        1 ? (
                                        <View style={styles.tickpassContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickpassContainer}
                                        ></View>
                                      )}
                                      {subCheck?.SubInspectionCheck?.status ==
                                        false ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        0 ? (
                                        <View style={styles.tickfailContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickfailContainer}
                                        ></View>
                                      )}
                                    </View>
                                  </View>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      marginTop: "10px",
                                      marginLeft: "18px",
                                    }}
                                  >
                                    <Text style={styles.detailsText2}>
                                      Right rear
                                    </Text>
                                    <View style={styles.passfailContainer}>
                                      {subCheck?.SubInspectionCheck?.status ==
                                        true ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        1 ? (
                                        <View style={styles.tickpassContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickpassContainer}
                                        ></View>
                                      )}
                                      {subCheck?.SubInspectionCheck?.status ==
                                        false ||
                                      subCheck?.SubInspectionCheck?.status ==
                                        0 ? (
                                        <View style={styles.tickfailContainer}>
                                          <Image
                                            style={{
                                              width: "16px",
                                              marginLeft: "2px",
                                            }}
                                            source={TicketImg}
                                          />
                                        </View>
                                      ) : (
                                        <View
                                          style={styles.tickfailContainer}
                                        ></View>
                                      )}
                                    </View>
                                  </View>
                                </>
                              )}
                            </>
                          ))}
                      </>
                    ) : null
                  )}

                  <View
                    style={[
                      styles.inspectionsecondContainer,
                      { marginTop: "20px", marginLeft: -10 },
                    ]}
                  >
                    <View style={styles.failpassbox}>
                      <View style={styles.boxinspectionContainer}>
                        <Text style={styles.boxinspectionText}>
                          VEHICLE INSPECTION
                        </Text>
                        <Text style={styles.circleoneText}>
                          (Circle One)
                        </Text>
                      </View>
                      <View style={styles.michiganResultOption}>
                        {certificateData &&
                        certificateData.finalStatus === "pass" ? (
                          <MichiganHandCircle />
                        ) : null}
                        <Text style={styles.boxpassText}>PASS</Text>
                      </View>
                      <View style={styles.michiganResultOption}>
                        {certificateData &&
                        certificateData.finalStatus === "fail" ? (
                          <MichiganHandCircle />
                        ) : null}
                        <Text style={styles.boxpassText}>FAIL</Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>

              <View style={styles.tobecompletedWidth}>
                <View style={styles.tobecompletedContainer}>
                  <View
                    style={{
                      width: "50%",
                      marginLeft: "20px",
                      marginTop: "10px",
                      marginRight: "20px",
                    }}
                  >
                    <Text>TO BE COMPLETED BY INSPECTOR</Text>
                  </View>
                </View>
                <View style={styles.tobecompletedContainer}>
                  <View
                    style={{
                      width: "50%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    <Text style={[styles.threeinputFields, handwritingStyle]}>Chex Inc.</Text>
                    <Text style={styles.lyftdriverName}>
                      COMPANY/FACILITY NAME
                    </Text>
                  </View>
                  <View
                    style={{
                      width: "50%",
                      marginRight: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    <Text style={[styles.threeinputFields, handwritingStyle]}>{`${
                      certificateData && certificateData.Inspectorname
                    } ${
                      certificateData && certificateData.InspectorlastName
                    }`}</Text>
                    <Text style={styles.lyftdriverName}>INSPECTOR NAME</Text>
                  </View>
                </View>
                <View style={styles.tobecompletedContainer}>
                  <View
                    style={{
                      width: "50%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    <Text style={[styles.threeinputFields, handwritingStyle]}>
                      {certificateData && certificateData?.stateAddress}
                    </Text>
                    <Text style={styles.lyftdriverName}>
                      COMPANY/FACILITY ADDRESS
                    </Text>
                  </View>
                  <View
                    style={{
                      width: "50%",
                      marginRight: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    <Text style={[styles.threeinputFields, handwritingStyle]}>
                      {moment(
                        new Date(
                          certificateData && certificateData?.reviewedDate
                        )
                      ).format("MM/ DD /YYYY")}
                    </Text>
                    <Text style={styles.lyftdriverName}>
                      INSPECTION DATE (document expires one year from this date)
                    </Text>
                  </View>
                </View>
              </View>
              {/*<Text style={styles.bottomPara}>*/}
              {/*  Applicants who do not match the photo on their driver’s license*/}
              {/*  or do not have the proper documents, cannot complete an*/}
              {/*  inspection. Failing inspections can only be remedied by the same*/}
              {/*  shop on the same day. If an applicant fails the inspection and*/}
              {/*  is unable to fix the issues on the spot, a new appointment must*/}
              {/*  be made, and a new inspection form must be used.*/}
              {/*</Text>*/}
              {/*<Text style={styles.bottomPara}>*/}
              {/*  This inspection form reflects a 19 point inspection only on the*/}
              {/*  date of the inspection listed above. For purposes of this*/}
              {/*  inspection, the wheels were not removed from the vehicle, and*/}
              {/*  the vehicle was not put on a lift, nor was it checked for*/}
              {/*  emissions.*/}
              {/*</Text>*/}
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const LyftCertificateMichiganDowmloadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template3");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <LyftCertificateMichiganDowmload
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.lyftVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setLyftReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LyftCertificateMichiganDowmloadConnected);
